import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import withBoxStyle from '../../../HOC/layout/withBoxStyle';
import {
  EMAIL_ALREADY_REGISTERED_HEADING,
  EMAIL_ALREADY_REGISTERED_MESSAGE,
  BUTTON_ENTER_ACCOUNT,
} from '../../../constants';
import LoginRegistrationHeader from '../../../components/layout/LoginRegistrationHeader';

const EmailAlreadyRegistered: React.FC = withBoxStyle(() => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/login', { replace: true });
  };

  return (
    <Box sx={{ p: 3 }} className="d-flex flex-column flex-1">
      <LoginRegistrationHeader />
      <Box pt={5}>
        <Typography variant="h4" color="primary" mb={1.5}>
          {EMAIL_ALREADY_REGISTERED_HEADING}
        </Typography>
        <Typography variant="body1">
          {EMAIL_ALREADY_REGISTERED_MESSAGE}
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 'auto', mb: 4.5 }}
        onClick={handleNavigate}
      >
        {BUTTON_ENTER_ACCOUNT}
      </Button>
    </Box>
  );
});

export default EmailAlreadyRegistered;
